import {Component, ViewChild, HostListener} from '@angular/core';
import {UntypedFormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {User} from './Interfaces/User';
import {Subscription, Subject} from 'rxjs';
import {GlobalEventsManager} from './GlobalEventManager';
import {MenusComponent} from './AppScreens/menus/menus.component';
import {NavItem} from './Interfaces/NavItem';
import {ConfirmationDialogComponent} from './Component/confirmation-dialog/confirmation-dialog.component';
import {SharedVarService} from './AppScreens/shared-service.service';
// MDB Angular Pro
import * as XLSX  from 'xlsx';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {SwUpdate} from '@angular/service-worker';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  timeoutId;
  userInactive: Subject<any> = new Subject();

  title = 'CSP';
  fullName: string = ""
  roleIn: string = ""
  showLogin: boolean = true; showAccount: boolean = false; showHelp: boolean = false;
  menusFound: boolean = false;
  underMaint: boolean = false;
  private navItems: NavItem[];
  myAccount: NavItem;
  myHelp: NavItem;
  phoneApp: boolean = false;
  private userObj: User;
  accountOpenState: boolean = false;
  showSpinner: boolean = false;
  showSuccess: boolean = false;
  message: string | null = "";

  messageIn: string = "";
  headerIn: string = "Success!";
  routeIn: string = "";
  myClassName = "success";
  mySpeechBubble = "speech-bubble";
  submitHit:boolean = false;
  helpOpen:boolean = false;
  accOpen:boolean = false;
  fileName= 'ExcelSheet.xlsx';
  private menuComp: MenusComponent;
  @ViewChild('accPanel') accPanel;
  @ViewChild('helpPanel') helpPanel;
  varIn : string = "--left: 809px; --top: 100px";
  private varIn2: SafeStyle;
  showMenuItems:boolean=false;
  menuClick: string="child";
  navChildren: NavItem[];
  private doc: ClientRect | DOMRect;

  refresh(): void {
    window.location.reload();
  }


  showMenu(inIn: NavItem[]){
    this.helpPanel.close();
    this.helpOpen = false;
    this.accPanel.close();
    this.accOpen = false;
    this.navChildren = inIn
    this.menuClick="child";

    this.showMenuItems=true;

    var el = document.getElementById('menuCanvas');
    if (el!=null){
      el.style.animation = 'none';
      el.offsetHeight; /* trigger reflow */
      el.style.animation = null;
    }

    setTimeout(() => {
      this.getCoords();
    },30)


  }
  hideMenu(){
    this.showMenuItems=false;

  }

  getCoords(){
    this.doc =  document.activeElement.getBoundingClientRect();
    var xxx = this.doc.left;
    var top = this.doc.top + this.doc.height + 20;
    var wid = this.doc.width/2
    var mid = xxx + wid;
    this.showMenuItems=true;

    var ddd  = document.getElementById("menuCanvas");
    mid =  mid - ddd.offsetWidth/2
    this.varIn = "--left: "+ Math.round(mid) + "px; --top: " + Math.round(top) + "px;";
    this.varIn2 = this.sanitizer.bypassSecurityTrustStyle(this.varIn);
  }


  constructor(private sanitizer: DomSanitizer, fb: UntypedFormBuilder, private router: Router, private  globalEventsManager: GlobalEventsManager, public dialog: MatDialog, private service: SharedVarService, private swUpdate: SwUpdate) {
    this.checkTimeOut();


    this.userInactive.subscribe((message) => {
      this.showLogin = true;
      this.router.navigate([""]);

      setTimeout(() => {
        this.refresh();

      },1000)

    }


  );




    this.globalEventsManager.navItems.subscribe((mode: NavItem[]) => {
      this.navItems = mode;
    });

    this.globalEventsManager.myAccount.subscribe((mode: NavItem) => {
      this.myAccount = mode;
    });

    this.globalEventsManager.underMaint.subscribe((mode: boolean) => {
      this.underMaint = mode;
    });


    this.globalEventsManager.myHelp.subscribe((mode: NavItem) => {
      this.myHelp = mode;
    });

    this.globalEventsManager.showLogin.subscribe((mode: boolean) => {
      this.showLogin = mode;
    });

    this.globalEventsManager.theirName.subscribe((mode: any) => {
      this.fullName = mode;
    });

    this.globalEventsManager.role.subscribe((mode: any) => {
      this.roleIn = mode;
    });


    this.globalEventsManager.userObj.subscribe((mode: User) => {
      this.userObj = mode;
    });

    this.globalEventsManager.menuFound.subscribe((mode: boolean) => {
      this.menusFound = mode;
    });

    this.globalEventsManager.showSpinner.subscribe((mode: boolean) => {

      if (this.showSpinner==true){
        this.showSpinner = false;
      }else{
        this.showSpinner = true;
      }
    });


  }


  checkTimeOut() {
    this.timeoutId = setTimeout(
      () => this.userInactive.next("User has been inactive for 30 minutes"), 1800000
    );
  }

  @HostListener('window:keydown')
  @HostListener('window:mousedown')
  checkUserActivity() {

    clearTimeout(this.timeoutId);

    this.checkTimeOut();
  }

  confirmHit(){
    this.showSuccess = false;
    this.service.setConfirmed(true);
  }

  showConfirmBanner(headerIn: string, dataIn: string, routeIn:string){
    this.headerIn = headerIn;
    this.messageIn = dataIn;
    this.showSuccess = true;
    this.routeIn = routeIn;
    this.myClassName = "trouble";
    this.mySpeechBubble = "speech-bubbleTrouble";
  }

  showSuccessBanner(headerIn: string, dataIn: string, routeIn:string){
    if (headerIn!=""){
      this.headerIn = headerIn;
    }else {
      this.headerIn = "Success!";
    }
    this.messageIn = dataIn;
    this.showSuccess = true;
    this.myClassName = "success";
    this.mySpeechBubble = "speech-bubble";
    setTimeout(() => {
      this.showSuccess = false;
      if (routeIn!=""){
        this.router.navigate([routeIn]);
      }
    },3000)


  }



  exportexcel(): void
  {
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);

  }


  cancelButton(){
    this.showSuccess = false;
  }


  closeSuccess(){
    this.showSuccess = false;
  }

  get user() { return this.userObj;}





  ngOnInit() {

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(() => {
        if(confirm("New version available. Load New Version?")) {
          window.location.reload();
        }
      });
    }

    this.myAccount = {} as NavItem;
    this.myHelp = {} as NavItem;
    if (window.innerWidth <= 1549){
      this.phoneApp = true;
    }
  }

  routeIt(fromWhere: string){
    if (fromWhere=="A"){
      this.router.navigate(["profile"]);
    }else if (fromWhere=="H"){
      this.router.navigate(["contact"]);
    }else{
      this.router.navigate(["driverhome"]);
    }

  }

 closeAcctPanel(){
   this.accPanel.close();
   this.accOpen = false;
 }

  showHideAccount(){
    this.showMenuItems = false;
    if (this.helpPanel!=null){
      this.helpPanel.close();
    }
    if (!this.accOpen){
      this.accPanel.open();
      this.accOpen = true;
    }else{
      this.accPanel.close();
      this.accOpen = false;
    }
  }

  showHideHelp(){
    this.showMenuItems = false;
    this.accPanel.close();
    if (!this.helpOpen){
      this.helpPanel.open();
      this.helpOpen = true;
    }else{
      this.helpPanel.close();
      this.helpOpen = false;
    }


  }


  forgot(){
    this.router.navigate(["user"]);
  }


  showCharts(){

      this.menusFound = true;
      this.router.navigate(["charts"]);


  }

  openMenus(){

    if (!this.showLogin && this.phoneApp && this.userObj.role=='MISC' && this.userObj.company_code=='M0995'){
      this.router.navigate(["driverhome"]);
    }else{
      this.router.navigate(["charts"]);
    }

    if (this.menusFound){
      this.menusFound = false;
    }else{
      this.menusFound = true;
      this.router.navigate(["charts"]);
    }

  }

  hideMenus(){
    setTimeout(() => {
      this.hideMenu();
    },600)

  }


  logout(){

    setTimeout(() => {
      this.doLogout();
    },400)

  }

  showTruckerScreen(){
    this.menusFound = false;
    this.router.navigate(["driverhome"]);

  }

  signUp(){
    this.router.navigate(["newuser"]);
  }

  doLogout(){
    this.showMenuItems = false;
    this.menuClick="childExit";
    this.navItems = [];
    this.fullName = '';
    this.roleIn = '';
    this.showLogin = true;
    this.router.navigate(["login"]);
  }

  openDialog(errorIn:string) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      id: 1,
      title: 'Severe Error',
      data: errorIn,
      panelClass: 'mat-dialog-container'
    };


    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => console.log("Dialog output:", data)
    );

  }




}
